import type { QueryClient } from '@tanstack/react-query';

import type { AppShellApiClient } from '../shared/types';
import createQueryConfig from '../queries';
import createDebug from './debug';

const debug = createDebug('fetch-calendar-v2-opt-in');

/**
 * Whether the user chose calendar-v2 while their merchant is still on the old
 * calendar.
 *
 * Never rejects: it runs during bootstrap, and on any failure the old calendar
 * is the right answer.
 */
export async function fetchCalendarV2OptIn(
  apiClient: AppShellApiClient,
  queryClient: QueryClient
): Promise<boolean> {
  try {
    const response = await queryClient.fetchQuery(
      createQueryConfig(queryClient, apiClient).calendarConfiguration()
    );

    return response.data.attributes.new_calendar_enabled === true;
  } catch (error) {
    // Message only, never the error object: authenticated queries attach their
    // bearer token to it (see injectErrorMetadata in ../queries).
    debug(
      error instanceof Error ? `${error.name}: ${error.message}` : String(error)
    );
    return false;
  }
}
